// eslint-disable-next-line jira/filename-case
import React, { useEffect } from 'react';
// eslint-disable-next-line jira/restricted/@atlassian+jira-entry-point
import { useEntryPoint } from '@jira/platform__entry-point/src/controllers/use-entry-point/index.tsx';
import { JiraEntryPointContainer } from '@jira/platform__entry-points-container/src/index.tsx';
import { upflowIframeComponentEntrypoint } from './upflowIframeComponentEntrypoint.entrypoint.tsx';
import { useUpflowModal } from './controllers/index.tsx';

const entryPointParams = {};
const props = {};
export const AsyncUpflowIframeComponent = (): React.JSX.Element => {
	const { entryPointActions, entryPointReferenceSubject } = useEntryPoint(
		upflowIframeComponentEntrypoint,
		entryPointParams,
	);

	const [{ renderUpflowModal }] = useUpflowModal();

	// Violating react-entrypoint/no-load-in-hooks so we can experiment faster: https://hello.atlassian.net/wiki/spaces/JIE/pages/4772823699/LDR+Entrypoint+Load+Via+Hooks+For+Faster+Experimentation
	// eslint-disable-next-line @atlassian/react-entrypoint/no-load-in-hooks
	useEffect(() => {
		if (renderUpflowModal) {
			entryPointActions.load();
		}
	}, [entryPointActions, renderUpflowModal]);

	return (
		<JiraEntryPointContainer
			id="issue-onboarding-modal-lazy"
			packageName="AsyncUpflowIframeComponent"
			placeholderName="async-upflow-iframe-modal"
			entryPointReferenceSubject={entryPointReferenceSubject}
			fallback={null}
			runtimeProps={props}
		/>
	);
};
